import { render } from "./RemoveExport.vue?vue&type=template&id=663cff98&scoped=true"
import script from "./RemoveExport.vue?vue&type=script&lang=js"
export * from "./RemoveExport.vue?vue&type=script&lang=js"

import "./RemoveExport.vue?vue&type=style&index=0&id=663cff98&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-663cff98"]])

export default __exports__